// extracted by mini-css-extract-plugin
module.exports = {"textarea":"DescriptionTextarea_textarea__3ae73"};